import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export const PurchaseOrderDetailsConfirmModal = () => {
  const { isProcessing, isConfirmOpen, closeConfirmModal, confirmModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;
  const { t } = useTranslation('purchaseOrderDetails');

  return (
    <Dialog onClose={closeConfirmModal}
      open={isConfirmOpen}>
      <DialogTitle>
        {t('confirmModal.title')}
        <CloseDialogAction onCancel={closeConfirmModal} />
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('confirmModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='100%'>
          <Button variant='secondary'
            fullWidth
            size="lg"
            disabled={isProcessing}
            onClick={closeConfirmModal}>
            {t('confirmModal.cancel')}
          </Button>
          <Button variant='primary'
            fullWidth
            size="lg"
            disabled={isProcessing}
            onClick={confirmModal}>
            {t('confirmModal.confirm')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};